import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchChangePass } from "./loginAPI";
import swal from 'sweetalert';
export interface ChangePassState {
  changePass: any;
  status: "idle" | "loading" | "failed" | "success";
  accessToken : string;
  isAdmin: Boolean;
}

const initialState: ChangePassState = {
  changePass: [],
  status: "idle",
  accessToken : '',
  isAdmin: false
};

export const GetChangePass = createAsyncThunk(
  "ChangePass/fetchChangePass",
  async (data: any) => {
    const response = await fetchChangePass(data);
    return response;
  }
);

export const ChangePassSlice = createSlice({
  name: "ChangePass",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetChangePass.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetChangePass.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetChangePass.fulfilled, (state, action) => {
          state.status = "success";
          state.changePass=action.payload.data;
       
      });
  },
});

export const {} = ChangePassSlice.actions;

export const selectChangePass = (state: RootState) => {
  return state.ChangePass.changePass;
};



export default ChangePassSlice.reducer;
